<template>
  <div class="home">
    <a-layout>
      <div class="page-listHeader">
        <a-layout-header class="header">
          <div :class="[$i18n.locale === 'zh-CN' ? 'logo' : 'logo-en']" />
          <a-dropdown>
            <div class="user">
              <img
                class="urlImgCss"
                :src="config.urlImg + urlPath"
                v-if="urlPath !== '1'"
              />
              <img
                class="urlImgCss"
                src="./image/user.jpg"
                v-if="urlPath === '1'"
              />
              <span>{{ name }}</span>
            </div>
            <a-menu slot="overlay" @click="handleClick">
              <!--<a-sub-menu title="基本信息" key="test">-->
              <!--<a-menu-item @click="showModal(user.personContactname, 1)"-->
              <!--&gt;姓名：{{ user.personContactname }}</a-menu-item-->
              <!--&gt;-->
              <!--<a-menu-item @click="showModal(user.personEmail, 2)"-->
              <!--&gt;邮箱：{{ user.personEmail }}</a-menu-item-->
              <!--&gt;-->
              <!--<a-menu-item @click="showModal(user.personMobilephone, 3)"-->
              <!--&gt;手机号：{{ user.personMobilephone }}</a-menu-item-->
              <!--&gt;-->
              <!--</a-sub-menu>-->
              <a-sub-menu>
                <span slot="title" class="maenSpan">{{
                  $tc('lang.header.Language')
                }}</span>
                <a-menu-item key="11">{{ $tc('lang.header.zh') }}</a-menu-item>
                <a-menu-item key="12">English</a-menu-item>
              </a-sub-menu>
              <a-menu-item @click="() => (this.visible1 = true)">{{
                $tc('lang.menuGoodsSpace.Change_Password')
              }}</a-menu-item>

              <a-menu-item @click="logout">{{
                $tc('lang.menuGoodsSpace.Log_out')
              }}</a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-layout-header>
      </div>
      <a-layout>
        <a-layout-sider width="200" class="left">
          <a-menu
            mode="inline"
            :selectedKeys="
              defaultSelectedKeys.length == 1 ? defaultSelectedKeys : ['myhome']
            "
            :defaultOpenKeys="defaultOpenKeys"
            :style="{ height: '100%', borderRight: 0 }"
          >
            <a-menu-item
              key="myhome"
              style="padding: 0 34px 0 24px"
              @click="goRouter('/')"
            >
              <a-icon type="home" />
              <span>{{ $tc('lang.menuList.My_Minder') }}</span>
            </a-menu-item>
            <a-sub-menu key="sub1">
              <span slot="title"
                ><a-icon type="cloud-download" />{{
                  $tc('lang.menuList.Instant_Order')
                }}</span
              >
              <a-menu-item key="goods" @click="goRouter('/goods')">{{
                $tc('lang.menuList.Product_Inspection')
              }}</a-menu-item>
              <a-menu-item key="factory" @click="goRouter('/factory')">{{
                $tc('lang.menuList.Factory_Assessment')
              }}</a-menu-item>
              <a-menu-item
                key="supervision"
                @click="goRouter('/supervision')"
                >{{ $tc('lang.menuList.Loading_Supervision') }}</a-menu-item
              >
            </a-sub-menu>
            <a-sub-menu key="sub9">
              <span slot="title"
                ><a-icon type="user" />{{
                  $tc('lang.menuList.User_Center')
                }}</span
              >
              <a-menu-item key="basic" @click="goRouter('/basic')">{{
                $tc('lang.menuList.General_Information')
              }}</a-menu-item>
              <!--<a-menu-item key="myWallet" @click="goRouter('/myWallet')">{{
                $tc('lang.menuList.My_Wallet')
              }}</a-menu-item>-->
              <a-menu-item key="mySetMeal" @click="goRouter('/mySetMeal')">{{
                $tc('lang.menuList.My_Package')
              }}</a-menu-item>
              <a-menu-item key="myVouchers" @click="goRouter('/myVouchers')">{{
                $tc('lang.menuList.My_Coupons')
              }}</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub3">
              <span slot="title"
                ><a-icon type="profile" />{{
                  $tc('lang.menuList.My_Ordre')
                }}</span
              >
              <a-menu-item key="allorder" @click="goRouter('/allorder')">{{
                $tc('lang.menuList.Order_List')
              }}</a-menu-item>
              <a-menu-item
                key="notFinished"
                @click="goRouter('/notFinished')"
                >{{ $tc('lang.menuList.Uncompleted') }}</a-menu-item
              >
              <a-menu-item key="complete" @click="goRouter('/complete')">{{
                $tc('lang.menuList.Completed')
              }}</a-menu-item>
              <a-menu-item key="cancel" @click="goRouter('/cancel')">{{
                $tc('lang.menuList.Canceled')
              }}</a-menu-item>
              <a-menu-item key="draft" @click="goRouter('/draft')">{{
                $tc('lang.menuList.Drafts')
              }}</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub5">
              <span slot="title"
                ><a-icon type="project" />{{
                  $tc('lang.menuList.My_Reports')
                }}</span
              >
              <a-menu-item
                key="reportManage"
                @click="goRouter('/reportManage')"
                >{{ $tc('lang.menuList.Inspection_Reports') }}</a-menu-item
              >
            </a-sub-menu>
            <a-sub-menu key="sub6">
              <span slot="title"
                ><a-icon type="solution" />{{
                  $tc('lang.menuList.My_Review')
                }}</span
              >
              <a-menu-item key="noEvaluate" @click="goRouter('/noEvaluate')">{{
                $tc('lang.menuList.Wait_for_Review')
              }}</a-menu-item>
              <a-menu-item
                key="yesEvaluate"
                @click="goRouter('/yesEvaluate')"
                >{{ $tc('lang.menuList.Reviewed') }}</a-menu-item
              >
            </a-sub-menu>
          </a-menu>
        </a-layout-sider>
        <a-layout style="padding: 24px">
          <a-layout-content class="content2">
            <div style="float: left" v-if="this.$route.path != '/'">
              <span class="page-spa">&nbsp;</span>
              &nbsp;&nbsp;&nbsp;
              <span>{{ $tc('lang.menuList.current_location') }}:</span>
              &nbsp;&nbsp;&nbsp;
              <a-breadcrumb>
                <a-breadcrumb-item
                  ><router-link to="/">{{
                    $tc('lang.menuList.My_Minder')
                  }}</router-link></a-breadcrumb-item
                >
                <a-breadcrumb-item v-for="item in urlName" :key="item.name">
                  <router-link
                    :to="item.path"
                    v-if="$i18n.locale === 'zh-CN'"
                    >{{ item.name }}</router-link
                  >
                  <router-link
                    :to="item.path"
                    v-if="$i18n.locale === 'en-US'"
                    >{{ item.enName }}</router-link
                  >
                </a-breadcrumb-item>
              </a-breadcrumb>
            </div>
            <router-view> </router-view>
          </a-layout-content>
        </a-layout>
      </a-layout>
      <a-modal
        :title="$tc('lang.menuGoodsSpace.Change_Password')"
        :width="350"
        :visible="visible1"
        :maskClosable="false"
        :destroyOnClose="true"
        :okText="$tc('lang.UserCenter.Confirm')"
        :cancelText="$tc('lang.UserCenter.Cancel')"
        @ok="handleOk1"
        :confirmLoading="confirmLoading1"
        @cancel="handleCancel1"
      >
        <div>
          <a-form :form="form1">
            <a-form-item>
              <a-input
                :placeholder="
                  $tc('lang.UserCenter.Please_enter_the_original_password')
                "
                type="password"
                v-decorator="[
                  'oldPassword',
                  { rules: [{ required: true, message: '请输入' }] },
                ]"
              >
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                :placeholder="$tc('lang.UserCenter.Check_New_password')"
                type="password"
                v-decorator="[
                  'newPassword',
                  { rules: [{ required: true, message: '请输入' }] },
                ]"
              >
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                :placeholder="$tc('lang.UserCenter.Check_password_tow')"
                type="password"
                v-decorator="[
                  'newPassword1',
                  { rules: [{ required: true, message: '请输入' }] },
                ]"
              >
              </a-input>
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
    </a-layout>
  </div>
</template>
<script>
export default {
  inject: ['reload'],
  data() {
    return {
      collapsed: false,
      defaultSelectedKeys: [],
      defaultOpenKeys: ['sub1'],
      urlName: [],
      user: {},
      name: '',
      changeValue: '',
      changeType: '',
      visible: false,
      visible1: false,
      form1: this.$form.createForm(this),
      confirmLoading1: false,
      urlPath: '1',
    };
  },
  watch: {
    $route() {
      this.getUrl();
      this.getMenu();
    },
  },
  created() {
    console.log(this.$route);
    this.getUrl();
    this.getMenu();
    // 获取用户sessionStorage信息
    if (sessionStorage.getItem('user') !== null) {
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      this.getMenu();
      if (
        this.user.personHeadphotoList !== null &&
        this.user.personHeadphotoList.size !== 0
      ) {
        this.user.personHeadphotoList.forEach((value) => {
          this.urlPath = value.mediaPath;
        });
      }
      if (this.user.personContactname) {
        this.name = this.user.personContactname;
      } else if (this.user.personEmail) {
        this.name = this.user.personEmail;
      } else if (this.user.personMobilephone) {
        this.name = this.user.personMobilephone;
      }
      console.log('urlPath', this.urlPath);
    }
    // 获取国际化sessionStorage信息
    if (sessionStorage.getItem('lang') !== null) {
      this.$i18n.locale = JSON.parse(sessionStorage.getItem('lang')) || '';
    }
  },
  methods: {
    // 跳转路由
    goRouter(value) {
      this.$router.push(value);
    },
    /*面包屑方法*/
    getUrl() {
      const pathSegment = location.pathname.split('/').filter((i) => i);
      this.urlName = [];
      let str = '';
      for (let j = 0; j < pathSegment.length; j++) {
        str += `/${pathSegment[j]}`;
        for (let i = 0; i < this.$route.matched.length; i++) {
          if (this.$route.matched[i].path === str) {
            this.urlName.push({
              name: this.$route.matched[i].name,
              enName: this.$route.meta.enName,
              path: this.$route.matched[i].path,
            });
          }
        }
      }
    },
    // 退出登录
    logout() {
      this.$cookie.delete('token');
      sessionStorage.removeItem('user');
      this.$router.push('/login');
    },
    //语言切换
    handleClick(e) {
      // 页面路由判断
      this.current = [];
      if (e.key === '11') {
        console.log('changeLangEvent');
        if (this.$i18n.locale === 'en-US') {
          this.$i18n.locale = 'zh-CN'; //关键语句
          console.log('zh:', this.$i18n.locale);
          sessionStorage.setItem(
            'lang',
            JSON.stringify(this.$i18n.locale || ''),
          );
          this.reload();
        }
      }
      if (e.key === '12') {
        console.log('changeLangEvent');
        if (this.$i18n.locale === 'zh-CN') {
          this.$i18n.locale = 'en-US'; //关键语句
          console.log('en:', this.$i18n.locale);
          sessionStorage.setItem(
            'lang',
            JSON.stringify(this.$i18n.locale || ''),
          );
          this.reload();
        }
      }
    },
    showModal(value, type) {
      this.changeValue = value;
      this.changeType = type;
      this.visible = true;
      if (type != 1) {
        setTimeout(() => {
          this.form.setFieldsValue({
            changeValue: value,
          });
        }, 0);
      }
    },
    // 获取menu当前选中项,展开选中项父级
    getMenu() {
      var defaultSelectedKeys = [];
      this.defaultSelectedKeys = [];
      if (this.$route.path.split('/')[1]) {
        defaultSelectedKeys.push(this.$route.path.split('/')[1]);
        this.defaultSelectedKeys = defaultSelectedKeys;
      }
      if (this.$route.meta.menu != undefined) {
        this.defaultOpenKeys.push(this.$route.meta.menu);
      }
      console.log('this.defaultSelectedKeys', this.defaultSelectedKeys.length);
      console.log('defaultSelectedKeys', this.defaultSelectedKeys);
    },
    // 修改密码
    handleOk1() {
      this.confirmLoading1 = true;
      this.form1.validateFields((err, values) => {
        if (!err) {
          console.log(values);
          // return;
          if (values.newPassword != values.newPassword1) {
            this.$message.error('两次输入密码不相同');
            this.confirmLoading1 = false;
          } else {
            this.$http
              .post('/hzwmj/person/updatePersonMassage', {
                personId: this.user.id,
                type: '9',
                oldPassword: values.oldPassword,
                newPasswordOne: values.newPassword,
                newPasswordTwo: values.newPassword1,
              })
              .then((data) => {
                if (data.data === '更改成功') {
                  this.visible1 = false;
                  console.log('data.data', data.data);
                  this.confirmLoading1 = false;
                  this.openNotification();
                } else {
                  this.$message.error(data.data);
                  this.confirmLoading1 = false;
                }
              })
              .catch(() => {
                this.$message.error('更改失败');
                this.confirmLoading1 = false;
              });
          }
        }
      });
    },
    // 修改成功信息
    openNotification() {
      setTimeout(() => {
        this.$notification.close(key);
        this.$cookie.delete('token');
        sessionStorage.removeItem('user');
        this.$router.push('/home');
      }, 5000);
      const key = `open${Date.now()}`;
      this.$notification.open({
        message: '提示',
        description: '修改成功，5后跳转至登录页面',
        btn: (h) => {
          return h(
            'a-button',
            {
              props: {
                type: 'primary',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$notification.close(key);
                  this.$cookie.delete('token');
                  sessionStorage.removeItem('user');
                  this.$router.push('/home');
                },
              },
            },
            '确定',
          );
        },
        key,
        onClose: () => {
          this.$cookie.delete('token');
          sessionStorage.removeItem('user');
          this.$router.push('/home');
        },
      });
    },
    handleCancel1() {
      this.visible1 = false;
    },
  },
};
</script>

<style lang="less">
.home {
  width: 100%;
  .page-spa {
    background-color: rgba(39, 86, 138, 1);
  }
  .ant-breadcrumb {
    display: inline;
  }
  .page-listHeader {
    .ant-layout-header {
      padding: 0 25px;
      background-color: #fff;
    }
  }
  overflow: hidden;
  .logo {
    width: 200px;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 5px 0 5px 0;
    float: left;
    background-image: url(./image/logo.jpg);
    background-size: 200px 60px;
    background-repeat: no-repeat;
  }
  .logo-en {
    width: 190px;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 2px 0 0 0;
    float: left;
    background-image: url(../home/image/logo_en.png);
    background-size: 180px 60px;
    background-repeat: no-repeat;
  }
  .left {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 64px);
    background: linear-gradient(to right bottom, #3682c1, #0c3281);
    > div ul {
      background: transparent;
      color: #fff;
    }
    .ant-menu-submenu-arrow {
      &::after {
        background: currentColor;
      }
      &::before {
        background: currentColor;
      }
    }
    .ant-menu-item-selected {
      background-color: #3488ce;
      color: #fff;
      &::after {
        border-right: 3px solid #fff;
      }
    }
  }
  .content2 {
    background: #f0f2f5;
    padding: 0;
    margin: 0;
    border: none;
    height: calc(100vh - 64px - 48px);
    overflow-y: auto;
    overflow-x: hidden;
    /*border: 1px solid rgba(0, 0, 0, 0.1);*/
    border-radius: 5px;
  }
  .ant-layout-header {
    padding: 0 25px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    .user {
      span {
        margin: 0 10px;
      }
    }
    .urlImgCss {
      width: 70px;
      border-radius: 50px;
    }
  }
  .ant-menu-submenu-title {
    text-align: left;
  }
  .ant-menu-item {
    text-align: left;
  }
}
</style>
